import React, { useEffect, useRef } from 'react';
import { DragAndDropLarge } from '@wix/wix-ui-icons-common/system';
import { classes, st } from './DragHandle.st.css.js';
import { useDragAndDropContext } from './DragAndDropContext';
import { useSortableTableRow } from './useSortableTableRow';

export interface DragHandleProps {
  id: string | number;
  className?: string;
}

export function DragHandle(props: DragHandleProps) {
  const { id, className } = props;

  const { setActivatorNodeRef } = useSortableTableRow({ id });

  const {
    eventHandlers,
    announcements,
    dragHandleRef: dragHandleRefProp,
    onDropAnimationEnd,
  } = useDragAndDropContext();

  const ariaDescribedBy = `draggable-table-row-description-${id}`;

  const dragHandleRef = useRef<HTMLElement | null>();

  useEffect(() => {
    if (onDropAnimationEnd) {
      return onDropAnimationEnd(id, dragHandleRef);
    }

    return;
  }, [id, onDropAnimationEnd]);

  return (
    <div
      {...eventHandlers?.handle?.({ id })}
      className={st(classes.root, {}, className)}
    >
      <div id={ariaDescribedBy} style={{ display: 'none' }}>
        {announcements?.itemDescription?.(id)}
      </div>
      <div
        ref={(e) => {
          dragHandleRef.current = e;
          setActivatorNodeRef(e);
          dragHandleRefProp?.(id, e);
        }}
        role="button"
        aria-describedby={ariaDescribedBy}
        aria-label={announcements?.dragHandleLabel?.(id)}
        className={classes.triggerIcon}
        tabIndex={0}
      >
        <DragAndDropLarge />
      </div>
    </div>
  );
}

export function isDragHandleNode(node: HTMLElement) {
  return node.classList.contains(classes.triggerIcon);
}
